const kpiPageCopy = {
  analytics: {
    applications: {
      sectionTitle: 'Results by application',
      itemLabel: 'Application',
      singularLabel: 'application',
      pluralLabel: 'applications',
      chartToggleLabel: 'Applications',
      emptyHeadline: 'No applications yet',
      emptyDescription: 'When you apply, you are offering to build with a brand—not sending a pitch into the void.',
      emptySteps: [],
      filterEmptyNoun: 'applications',
      sparseEncouragement: 'You have started choosing brands to build with. Keep applying where the fit is real.',
      lowVolumeHint: 'You are choosing who to build with. Keep applying where the work fits.',
    },
    invites: {
      sectionTitle: 'Results by invite',
      itemLabel: 'Invite',
      singularLabel: 'invite',
      pluralLabel: 'invites',
      chartToggleLabel: 'Invites',
      emptyHeadline: 'No invites yet',
      emptyDescription: 'When a brand invites you, they are asking to build with you. Those asks will show up here.',
      emptySteps: [],
      filterEmptyNoun: 'invites',
      sparseEncouragement: 'Brands are starting to ask you to build with them. Keep your profile current so they can see the work.',
      lowVolumeHint: 'Brands are starting to ask. Keep your profile current so they can see who they are building with.',
    },
    following: {
      sectionTitle: 'Results by brand',
      itemLabel: 'Brand',
      singularLabel: 'brand followed',
      pluralLabel: 'brands followed',
      chartToggleLabel: 'Following',
      emptyHeadline: 'You have not followed any brands yet',
      emptyDescription: 'Follow the brands you want to grow with. Their campaigns will be easier to find.',
      emptySteps: [],
      sparseEncouragement: 'You are choosing brands to grow with. Check back as they launch new campaigns.',
      lowVolumeHint: 'Every brand you follow is a relationship you are choosing to stay close to.',
    },
    saved: {
      sectionTitle: 'Results by campaign',
      itemLabel: 'Campaign',
      singularLabel: 'saved campaign',
      pluralLabel: 'saved campaigns',
      chartToggleLabel: 'Saved',
      emptyHeadline: 'No saved campaigns yet',
      emptyDescription: 'Save campaigns you want to build with, then apply when you are ready.',
      emptySteps: [],
      sparseEncouragement: 'You are starting a shortlist of work that fits. Apply when you are ready.',
      lowVolumeHint: 'Keep saving campaigns that fit. Apply when you are ready to build with that brand.',
    },
  },
  collaborationJourney: {
    emptyTitle: 'No accepted collaborations yet',
    emptyBody: 'When a brand accepts, the work of building together starts here.',
    pageTitle: 'Collaboration Journey',
    pageIntro: 'Your next step. Then the brand\'s.',
    sectionUrgent: 'Urgent',
    sectionAtRisk: 'At Risk',
    sectionAction: 'Needs Action',
    sectionWaiting: 'Waiting on Brand',
    sectionComplete: 'Completed',
    emptyUrgent: 'No urgent blockers right now.',
    emptyAtRisk: 'No collaborations are at risk.',
    emptyAction: 'No pending actions right now.',
    emptyWaiting: 'Nothing is currently waiting on the brand.',
    emptyComplete: 'No completed collaborations yet. Finished partnerships will appear here.',
  },
};

export default kpiPageCopy;
